import { Injectable } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import {  TreeNode, TreeTableNode } from "primeng/api";
import { BehaviorSubject } from "rxjs";
import { Bien } from "src/app/models/Bien";
import { Coordinates } from "src/app/models/Coordinates";
import { LotBynumOpe } from "src/app/models/LotBynumOpe";
import { Ope } from "src/app/models/Ope";
import { OptionResponseDto } from "src/app/models/OptionResponseDto";
import { Programme } from "src/app/models/Programme";
import { SearchOpeBiCriteria } from "src/app/models/SearchOpeBiCriteria";
import { SearchOpeCriteria } from "src/app/models/SearchOpeCriteria";
import { collabDto } from "src/app/models/collabDto";
import { entite } from "src/app/models/entite";
import { userProfilDto } from "src/app/models/userProfilDto";
import { vignetteOpe } from "src/app/models/vignetteOpe";
import { Option } from "src/domain/option";

@Injectable({
  providedIn: 'root'
})
export class shareOpeSevices {
 public showprogressbar: boolean=false;
 public callApi: boolean=false;

public affichenotfound:boolean=false;
  //to share display flag to component 
  
  public isDisplayOption: boolean = false;
  public isDisplayDocument: boolean = false;
  public isDisplaygalerie: boolean = false;
  public isDisplayPres: boolean = true;
  public isDisplayGrilleprix: boolean = false;

  public isPitUploadDisplayPlansPublication: boolean = false;
  public isPitUploadDisplayDocument: boolean = false;
  public isPitUploadDisplaygalerie: boolean = false;
  public isPitUploadDisplayPres: boolean = true;
  public isPitUploadDisplayEspaceVente: boolean = false;

  public addEntite: boolean = false;
  public isvisible = new BehaviorSubject<boolean>(false);
  public isRefrechVendeurs = new BehaviorSubject<boolean>(false);
  public isForModif : boolean = false;
  public isForModifvendeur : boolean = false;
    //public isForModifvendeur$ = this.isForModifvendeur.asObservable();

  //object behaviour to share data with other componet
  public data = new BehaviorSubject<Bien[]>([]);
  public listedesentites = new BehaviorSubject<entite[]>([]);
  public datas = new BehaviorSubject<Programme>(null!);
  public datasOpe = new BehaviorSubject<Ope>(null!);
  public pituploadlistope : Ope[] = [] ;
  public tabProgOpe = new BehaviorSubject<String>(null!);
  public dataOptions = new BehaviorSubject<OptionResponseDto[]>(null!);
  public datasource = new BehaviorSubject <Programme[]>([]);
  public datasourceOpe = new BehaviorSubject <Ope[]>([]);
  public vignetteDetails = new BehaviorSubject<vignetteOpe>(null!);
  public searchcritere = new BehaviorSubject<SearchOpeBiCriteria>(null!);
  public searchcrit = new BehaviorSubject<SearchOpeCriteria>(null!);
  public opeselec = new BehaviorSubject<Programme>(null!);
  public opeSelected = new BehaviorSubject<Ope>(null!);
  public VignettesOffOpe = new BehaviorSubject<vignetteOpe[]>([]);
  public elementTag = new BehaviorSubject<HTMLElement>(null!);
  public showErroe = new BehaviorSubject<boolean>(false);
  public showErroes: boolean=false;
  public entiteformshare = new BehaviorSubject<FormGroup<{
    nomentite: FormControl<string | null>;
    num_pere: FormControl<number | null>;
    type: FormControl<string | null>;
    adress1: FormControl<string | null>;
    adress2: FormControl<string | null>;
    adress3: FormControl<string | null>;
    ext: FormControl<number | null>;
    codepostal: FormControl<string | null>;
    telephone: FormControl<string | null>;
    formeJuridique: FormControl<string | null>;
    ville: FormControl<string | null>;
}>>(null!);
public userProfilshared =  new BehaviorSubject<userProfilDto>(null!);


  //observable to subscribe 
  public userProfilshared$ = this.userProfilshared.asObservable();
  public listedesentites$ = this.listedesentites.asObservable();
  public entiteformshare$ =this.entiteformshare.asObservable();
   public _opeselec = this.opeselec.asObservable;
  public elementTag$ = this.elementTag.asObservable;
  public datasource$ = this.datasource.asObservable();
  public datasourceOpe$ = this.datasourceOpe.asObservable();
  public datas$ = this.datas.asObservable();
  public datasOpe$ = this.datasOpe.asObservable();
  public tabProgOpe$ = this.tabProgOpe.asObservable();
  public dataOptions$ = this.dataOptions.asObservable();
  public data$ = this.data.asObservable();
  public showErroe$ = this.showErroe.asObservable(); 
  public searchcritere$ = this.searchcritere.asObservable();
  public searchcrit$ = this.searchcrit.asObservable();
  public isVisible$ = this.isvisible.asObservable();
  public isRefrechVendeurs$  = this.isRefrechVendeurs.asObservable();
  public vignetteDetails$ = this.vignetteDetails.asObservable();
  public VignettesOffOpe$= this.VignettesOffOpe.asObservable();
  public coordinates = new BehaviorSubject <Coordinates[]>([]);
  public coordinates$ = this.coordinates.asObservable();
  public noeudficheEntite  = new BehaviorSubject<any>(null!);
  public sendVendeur  = new BehaviorSubject<collabDto>(null!);
  
  public noeudficheEntite$ = this.noeudficheEntite.asObservable();
  public sendVendeur$ = this.sendVendeur.asObservable();
  public programForm: boolean= false;
  public initmap: boolean= true;
  public intSearchcrit: boolean = true;


  constructor() { }
 
  sendUserProfil(profil: userProfilDto){

    this.userProfilshared.next(profil);
  }

  sendFicheEntite(entite: any){
    this.noeudficheEntite.next(entite);

  }
  sendCoordinates(coordinates: Coordinates[]){

    this.coordinates.next(Object.assign([],coordinates))
  }
  sendboolean(data: boolean){
    this.showErroe.next(data);
  }
  sendElementTag(dataretirev: HTMLElement){
    this.elementTag.next(dataretirev);
  }

  sendFormBuilder(dataretirev: FormGroup){
    this.entiteformshare.next(dataretirev);
  }
  sendSearchCritere(searchcritere: SearchOpeBiCriteria){
    this.searchcritere.next(searchcritere);
  }

  sendSearchCrit(searchcrit: SearchOpeCriteria){
    this.searchcrit.next(searchcrit);
    
  }

  sendData(dataretriev: Bien[]) {
    this.data.next(Object.assign([], dataretriev))
  }
  sendListEntites(dataretriev: entite[]) {
    this.listedesentites.next(Object.assign([], dataretriev))
  }
  sendDatanew(dataretriev: LotBynumOpe[]) {
    this.data.next(Object.assign([], dataretriev))
  }
  sendOpe(dataretriev: Programme) {
    this.datas.next(dataretriev)
  }

  sendOpeN(dataretriev: Ope) {
    this.datasOpe.next(dataretriev)
  }

  sendTabProgOpe(tabactive: String) {
    this.tabProgOpe.next(tabactive)
  }

  sendOptions(optionsOpe: OptionResponseDto[]){
    this.dataOptions.next(Object.assign([], optionsOpe))
  }

  sendListeOpe(dataretirev: Programme[]){

    this.datasource.next(Object.assign([],dataretirev))
  }
  sendVendeurfromList(vendeur: collabDto){
    this.sendVendeur.next(vendeur);
  }

  sendOpes(dataretirev: Ope[]){
    this.datasourceOpe.next(Object.assign([],dataretirev))
  }

  sendSelectedOpe(dataretirev: Programme ){
    this.opeselec.next(dataretirev)
  }

  sendSelectedOpee(dataretirev: Ope ){
    this.opeSelected.next(dataretirev)
  }

  sendVisible(dataretirev: boolean){
    this.isvisible.next(dataretirev);
  }

  sendRefrechVendeurs(isRefrechVendeurs: boolean){
    this.isRefrechVendeurs.next(isRefrechVendeurs);
  }

  sendVignetteDetails(dataretirev: vignetteOpe){
    this.vignetteDetails.next(dataretirev);
  }

  fetchVignettesOffrOpe(dataretirev: vignetteOpe[]){
    this.VignettesOffOpe.next(dataretirev);
  }



}
